import { Forum, Message } from '@mui/icons-material';
import moment from 'moment';
import React, { useState } from 'react'
import "../../assets/scss/FeedbackModule.scss";
import ModalWindow from '../UI/ModalWindow';
import FeedbackResponse from './FeedbackResponse';


const FeedbackCard = (props) => {
    const [openResponse, setOpenResponse] = useState(false);
    const feedbackRating = (rating) => {
        const stars = [];
        for (let i = 1; i <= rating; i++) {
            stars.push(<span key={i} className="star active">★</span>);
        }
        return stars;
    }
    const feedback = props.feedback;
    return (
        <>
            <div className="card mb-3">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="d-flex align-items-center">
                            <Forum className="w-4 h-4 text-blue-600 mr-2" />
                            <span className="small font-weight-bold">{feedback?.schoolName}</span>
                        </div>
                        <span className="text-muted" style={{ fontSize: "12px" }}>{moment(feedback?.createdAt).fromNow()}</span>
                    </div>
                    <p className="card-text small mb-2 d-block text-truncate">{feedback?.description}</p>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>

                        <span className={`badge ${feedback?.anonymous ? 'badge-secondary' : 'badge-info'} mr-2`}>
                            By : {feedback?.name}
                        </span>
                        {
                            !!feedback?.feedbackToPeopleName && (
                                <span className={`badge badge-info mr-2`}>
                                    to : {feedback?.feedbackToPeopleName}
                                </span>
                            )
                        }
                            <small className="text-muted mr-2">Category: {feedback?.feedbackTypeName}</small>
                            {feedbackRating(feedback?.rating)}
                        </div>
                        <div>
                            <small className="btn btn-sm btn-outline-primary" onClick={() => setOpenResponse(true)}>View
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <ModalWindow
                backdrop="static"
                keyboard={false}
                fullWidth={false}
                modal={openResponse}
                toggleModal={() => setOpenResponse(false)}
                noModelHeader={true}
                // modalHeader={modalTitle}
                modalBody={
                    // <FeedBackModule
                    // onSubmit={onSubmitFeedback}
                    // onCancel={onCancelFeedback}
                    // />
                    <FeedbackResponse
                        handleCancel={() => setOpenResponse(false)}
                        feedback={feedback}
                    />
                }
            />
        </>
    )
}

export default FeedbackCard